<script setup lang="ts">
import DeleteMenuItem from "@/components/DeleteMenuItem/DeleteMenuItem.vue";
import { cardKey } from "@/components/StickyNote/injectKeys";
import ActionSource from "@/components/action/ActionSource.vue";
import type { BoardCard } from "@/model/card";
import { injectStrict } from "@/utils/vue";

import ActivityMenuItem from "./internal/ActivityMenuItem.vue";
import AlmMenuItem from "./internal/AlmMenuItem/AlmMenuItem.vue";
import BreakdownMenuItem from "./internal/BreakdownMenuItem.vue";
import ChangeArtMenuItem from "./internal/ChangeArtMenuItem/ChangeArtMenuItem.vue";
import ChangeProjectMenuItem from "./internal/ChangeProjectMenuItem/ChangeProjectMenuItem.vue";
import DevLinksMenuItem from "./internal/DevLinksMenuItem/DevLinksMenuItem.vue";
import DuplicateMenuItem from "./internal/DuplicateMenuItem.vue";
import EnablingTeamMenuItem from "./internal/EnablingTeamMenuItem/EnablingTeamMenuItem.vue";
import LinkMenuItem from "./internal/LinkMenuItem.vue";
import MirrorMenuItem from "./internal/MirrorMenuItem.vue";
import MirrorToArtBoardMenuItem from "./internal/MirrorToArtBoardMenuItem.vue";
import MoveMenuItem from "./internal/MoveMenuItem/MoveMenuItem.vue";
import PinMenuItem from "./internal/PinMenuItem.vue";
import ShareMenuItem from "./internal/ShareMenuItem/ShareMenuItem.vue";
import StickyStatusMenuItem from "./internal/StickyStatusMenuItem.vue";
import StickyTypeMenuItem from "./internal/StickyTypeMenuItem/StickyTypeMenuItem.vue";
import StoryPointsMenuItem from "./internal/StoryPointsMenuItem.vue";
import TeamMenuItem from "./internal/TeamMenuItem.vue";
import WsjfMenuItem from "./internal/WsjfMenuItem.vue";

const card = injectStrict(cardKey);

const trapOptions = {
  returnFocusOnDeactivate: false,
  // Focus trap should contain the card as well as the action menu
  extraElements: [card.id],
  // Fixes bug when card+dialog close at the same time (eg. when deleting a card)
  fallbackFocus: `[id='${card.id}']`,
};
</script>

<template>
  <ActionSource
    :id="'action-menu-' + card.id"
    v-focus-trap="trapOptions"
    value="action-menu"
    style="display: contents"
  >
    <StickyTypeMenuItem />
    <StickyStatusMenuItem />
    <WsjfMenuItem />
    <StoryPointsMenuItem />
    <ChangeProjectMenuItem />
    <ChangeArtMenuItem />
    <AlmMenuItem />
    <DevLinksMenuItem />
    <LinkMenuItem />
    <MoveMenuItem />
    <MirrorMenuItem />
    <MirrorToArtBoardMenuItem />
    <TeamMenuItem />
    <EnablingTeamMenuItem />
    <PinMenuItem />
    <DuplicateMenuItem />
    <ShareMenuItem />
    <BreakdownMenuItem />
    <ActivityMenuItem />
    <DeleteMenuItem :cards="[{ data: card } as BoardCard]" />
  </ActionSource>
</template>
